__turbopack_context__.v({
  "className": "inter_8ffbab30-module__HdY47W__className",
  "variable": "inter_8ffbab30-module__HdY47W__variable",
});
